import React, { useState } from 'react'
import { Search, Remove } from '../../atoms/NewIcons'

const SearchField = ({ size, disabled, placeholder, handleSearch, handleBlur = undefined, handleCancel = undefined, handleEnter = undefined }) => {
  const [status, setStatus] = useState('')
  const [currentValue, setCurrentValue] = useState('')

  function handleValueChange(event) {
    setStatus(event.target.value ? 'filled' : '')
    setCurrentValue(event.target.value)
    handleSearch(event.target.value)
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' && handleEnter) {
      handleEnter(event)
    }
  }

  const annullaRicerca = () => {
    if (status == 'filled') {
      setCurrentValue('')
      setStatus('')
      handleSearch('')
      handleCancel()
    }
  }

  return (
    <div className={'search-field search-field--' + (size ? size : 'lg')}>
      <input
        className="search-field__input"
        value={currentValue}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={handleValueChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        disabled={disabled}
      />
      <a className="search-field__icon" onClick={annullaRicerca}>
        {status == 'filled' ? <Remove /> : <Search />}
      </a>
    </div>
  )
}

export default SearchField
